import { inject, Injectable, signal } from '@angular/core'
import { WhatsappCallService } from './whatsapp-call.service'

@Injectable({ providedIn: 'root' })
export class ActiveCallWarningService {
  readonly #callService = inject(WhatsappCallService)

  readonly isVisible = signal(false)

  isCalling(): boolean {
    return this.#callService.isCalling()
  }

  show() {
    this.isVisible.set(true)
  }

  hide() {
    this.isVisible.set(false)
  }
}
